import { render, staticRenderFns } from "./ViewsConfigurator.vue?vue&type=template&id=4f9e53f9&scoped=true"
import script from "./ViewsConfigurator.vue?vue&type=script&lang=js"
export * from "./ViewsConfigurator.vue?vue&type=script&lang=js"
import style0 from "./ViewsConfigurator.vue?vue&type=style&index=0&id=4f9e53f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_lodash@4.17.21_prettier@2.8.8_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e53f9",
  null
  
)

export default component.exports